/** Normalize Windows / classic Mac line endings to LF. */
export function normalizeThumbnailTitleText(title) {
  return String(title || '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

/** Word-wrap thumbnail title for drawtext / preview (explicit newlines only). */
export function wrapThumbnailTitleText(title, { fontSize, videoWidth = 1080, paddingRatio = 0.12 }) {
  const normalized = normalizeThumbnailTitleText(title);
  if (!normalized) return '';

  const maxTextWidth = videoWidth * (1 - paddingRatio * 2);
  const avgCharWidth = fontSize * 0.52;
  const maxCharsPerLine = Math.max(6, Math.floor(maxTextWidth / avgCharWidth));

  const paragraphs = normalized.split('\n');
  const wrapped = [];

  for (const paragraph of paragraphs) {
    if (!paragraph.trim()) {
      wrapped.push('');
      continue;
    }
    const words = paragraph.trim().split(/\s+/);
    let currentLine = '';
    for (const word of words) {
      const candidate = currentLine ? `${currentLine} ${word}` : word;
      if (candidate.length <= maxCharsPerLine) {
        currentLine = candidate;
        continue;
      }
      if (currentLine) wrapped.push(currentLine);
      if (word.length > maxCharsPerLine) {
        let remaining = word;
        while (remaining.length > maxCharsPerLine) {
          wrapped.push(remaining.slice(0, maxCharsPerLine));
          remaining = remaining.slice(maxCharsPerLine);
        }
        currentLine = remaining;
      } else {
        currentLine = word;
      }
    }
    if (currentLine) wrapped.push(currentLine);
  }

  return wrapped.join('\n');
}

/** Match Lambda thumbnail drawtext line breaks (1080p, 12% side padding). */
export function formatThumbnailTitleForRender(title, bigText) {
  const fontSize = bigText !== false ? 150 : 100;
  return wrapThumbnailTitleText(title, { fontSize, videoWidth: 1080, paddingRatio: 0.12 });
}
